// extracted by mini-css-extract-plugin
export default {"buttonToAnswerQuestion":"E2-z","disabled":"F2-z","seeAllAnswers":"G2-z"};